import { render, staticRenderFns } from "./rightTab.vue?vue&type=template&id=7ebceddf&"
import script from "./rightTab.vue?vue&type=script&lang=ts&"
export * from "./rightTab.vue?vue&type=script&lang=ts&"
import style0 from "./rightTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports